module.exports = __webpack_public_path__ + "img/hong.a28a3c13.png";